import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import poolPondSvg from "../../../assets/images/svg/poolPond.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, usePoolCreateMutation, usePoolDeleteMutation, usePoolFindAllQuery, usePoolUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";

const Detail = ({ searchField }: any) => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [poolOne, setPoolOne] = useState<any>();
  const [poolList, setPoolList] = useState<any>();
  const [poolCount, setPoolCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = usePoolFindAllQuery(customQuery);
  const [saveBorder, setSaveBorder] = useState<boolean>(false);


  const [poolUpdate, poolUpdateResult] = usePoolUpdateMutation();
  const [poolCreate, poolCreateResult] = usePoolCreateMutation();
  const [poolDelete, poolDeleteResult] = usePoolDeleteMutation();

  const {
    data: commonPool,
    error: commonPoolError,
    isFetching: isCommonPoolFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_pool_type`);

  const {
    data: cost_source,
    error: cost_sourceError,
    isFetching: isCost_sourceFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);



  useEffect(() => {
    setPoolList(data?.data);
    setLoading(false);
    setPoolCount(poolList?.length);

    const tempSaveBorder = poolOne !== null ? poolOne?.save_border : false;
    setSaveBorder(tempSaveBorder)


    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, poolList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setPoolOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const poolData = arg;
    console.log(poolData);

    setPoolOne({
      id: poolData.id,
      code: poolData.code,
      name: poolData.name,
      cmn_invesetment_source: poolData.cmn_invesetment_source,
      cmn_pool_type: poolData.cmn_pool_type,
      budget_cost: poolData.budget_cost,
      used_date: poolData?.used_date,
      built_organization_description: poolData.built_organization_description,
      location: poolData.location,
      save_border_desicion: poolData.save_border_desicion,
    });
    setSaveBorder(poolData?.save_border)


    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (poolData) => {
    setPoolOne(poolData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (poolOne) {
      poolDelete(poolOne.id);
      setDeleteModal(false);
    }
  };

  const handleJobClicks = () => {
    setIsEdit(false);
    setPoolOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Төрөл",
        accessorKey: "pool_type_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Төсвийн эх үүсвэр",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "invesetment_source_name",
      },
      {
        header: "Төсөв",
        accessorKey: "budget_cost",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return (
            numberWithCommas(cellProps.row.original.budget_cost) + '₮'
          );
        },
      },
      {
        header: "Гүйцэтгэсэн байгууллага",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "built_organization_description",
      },

      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/construction/water/pool/and/pond/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const poolData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(poolData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const poolData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(poolData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: poolOne?.code,
      name: poolOne?.name,
      cmn_invesetment_source: poolOne?.cmn_invesetment_source,
      cmn_pool_type: poolOne?.cmn_pool_type,
      used_date: poolOne?.used_date,
      built_organization_description: poolOne?.built_organization_description,
      budget_cost: poolOne?.budget_cost,
      location: poolOne?.location,
      save_border_desicion: poolOne?.save_border_desicion,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      budget_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_invesetment_source: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      cmn_pool_type: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      save_border_desicion: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      used_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      built_organization_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const formData = new FormData();

        formData.append('id', poolOne ? poolOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('cmn_pool_type', values?.cmn_pool_type);
        formData.append('used_date', values?.used_date);
        formData.append('built_organization_description', values?.built_organization_description);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('location', values?.location);
        poolUpdate(formData)
      } else {
        const formData = new FormData();

        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('cmn_pool_type', values?.cmn_pool_type);
        formData.append('used_date', values?.used_date);
        formData.append('built_organization_description', values?.built_organization_description);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('location', values?.location);

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }

        poolCreate(formData)
        setResetFiles(true);
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={poolOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={poolPondSvg} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(poolCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                  setPoolOne(null);
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={poolList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Усан сан, хөв цөөрөм  мэдээлэл засах" : "Усан сан, хөв цөөрөм мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger"> Услалтын системийн бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Услалтын системийн нэр *</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="text-danger">Услалтын системийг ашиглалтанд оруулсан он *</Label>
                  <Input
                    name="used_date"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.used_date || ""}
                    invalid={
                      validation.touched.used_date && validation.errors.used_date
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.used_date && validation.errors.used_date ? (
                    <FormFeedback status="invalid">
                      {validation.errors.used_date}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="text-danger">Услалтын системийг барьсан байгууллагын нэр  *</Label>
                  <Input
                    name="built_organization_description"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.built_organization_description || ""}
                    invalid={
                      validation.touched.built_organization_description && validation.errors.built_organization_description
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.built_organization_description && validation.errors.built_organization_description ? (
                    <FormFeedback status="invalid">
                      {validation.errors.built_organization_description}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр *</Label>
                  <Input
                    name="save_border_desicion"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.save_border_desicion || ""}
                    invalid={
                      validation.touched.save_border_desicion && validation.errors.save_border_desicion
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                    <FormFeedback status="invalid">
                      {validation.errors.save_border_desicion}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">	Хөрөнгө орууллатын төрөл *</Label>
                  <Input
                    name="cmn_invesetment_source"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_invesetment_source || ""}
                    invalid={
                      validation.touched.cmn_invesetment_source &&
                        validation.errors.cmn_invesetment_source
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {cost_source?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_invesetment_source &&
                    validation.errors.cmn_invesetment_source ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_invesetment_source}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">	Төрөл *</Label>
                  <Input
                    name="cmn_pool_type"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_pool_type || ""}
                    invalid={
                      validation.touched.cmn_pool_type &&
                        validation.errors.cmn_pool_type
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {commonPool?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_pool_type &&
                    validation.errors.cmn_pool_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_pool_type}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Төсөвт өртөг *</Label>
                  <Input
                    name="budget_cost"
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/,/g, '');
                      validation.setFieldValue('budget_cost', rawValue);
                    }}
                    onBlur={validation.handleBlur}
                    value={numberWithCommas(validation.values.budget_cost) || ""}
                    invalid={
                      validation.touched.budget_cost && validation.errors.budget_cost
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.budget_cost && validation.errors.budget_cost ? (
                    <FormFeedback status="invalid">
                      {validation.errors.budget_cost}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Услалтын системийн байршил  *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Хамгаалалтын бүстэй эсэх*</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setSaveBorder(!saveBorder);
                    }}
                    checked={saveBorder}
                  />
                </div>


              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>

                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} />
              </Row>
            }

          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
